import { useState } from "react";
import { Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Translate } from "../../../../Enums/Tranlate";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import AdminService from "../../../../../services/AdminService";
import ConfirmModal from "../../../../common/ConfirmModal";
import DeleteModal from "../../../../common/DeleteModal";

const CardItem = ({ item, index, setShouldUpdate, setItem, setAddModal }) => {
	const [status, setStatus] = useState(!item.isBlocked);
	const [deleteModal, setDeleteModal] = useState(false);
	const [statusModal, setStatusModal] = useState(false);
	const adminService = new AdminService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	const changeStatusToggle = (e) => {
		let data = {
			isBlocked: status,
		};
		adminService.toggleStatus(item.id, data).then((res) => {
			if (res?.status === 200) {
				toast.success(Translate[lang].updated_status_successfully);
				setStatus(!status);
				setStatusModal(false);
			}
		});
	};

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.username}</td>
			<td>{item?.phone}</td>
			<td>{item?.email}</td>
			<td>
				<Badge className="text-capitalize" variant="outline-success light">
					{item?.admin_permissions[0]?.admin_role?.name?.toLocaleLowerCase()}
				</Badge>
			</td>
			<td>
				<Badge
					className={
						item?.id !== Auth?.admin?.id
							? "text-capitalize cursor-pointer"
							: "text-capitalize"
					}
					style={{
						opacity: item?.id !== Auth?.admin?.id ? "1" : ".9",
					}}
					onClick={() => {
						if (item?.id !== Auth?.admin?.id && isExist("update_admins")) {
							setStatusModal(true);
						}
					}}
					variant={`${status ? "success" : "danger"} light`}>
					{Translate[lang][status ? "active" : "deactive"]}
				</Badge>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_admins") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("delete_admins") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={adminService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
			{statusModal && (
				<ConfirmModal
					open={statusModal}
					title={item?.username}
					body={
						lang === "en"
							? `are you sure about changing status for this admin?`
							: "هل أنت متأكد من تغيير الحالة لهذا المسؤول؟"
					}
					button={Translate[lang].submit}
					submitButton={changeStatusToggle}
					onCloseModal={() => setStatusModal(false)}
				/>
			)}
		</tr>
	);
};
export default CardItem;
